<template>
    <div class="d3-chart gauge-tier">
        <loader class="panel-loader" v-if="!isDataLoaded"></loader>
        <div class="chart-container" v-if="isDataLoaded && !hasError">
            <div class="chart-controls">
                <div class="breadcrumb-container">
                    <ul class="breadcrumb" v-if="dataZoom.length">
                        <li v-on:click="dataZoomReset()" class="clickable">Top</li>
                        <li v-for="(zoom,index) in dataZoom" v-bind:class="breadcrumbClickable(index)" v-on:click="breadcrumbZoomOut(index)">{{parentLabel(zoom)}}</li>
                    </ul>
                </div>
                <div class="filter" v-if="hasFilter">
                    <template v-for="(filterValue, filterName) in filter">
                        <select class="form-control" v-model="filter[filterName]" v-on:change="getData()">
                            <option v-for="filterOption in filterOptions[filterName]" v-bind:value="filterOption.value">{{filterOption.label}}</option>
                        </select>
                    </template>
                </div>
                <div class="table-toggle clickable glyphicon" v-bind:class="tableView ? 'glyphicon-signal' : 'glyphicon-th-list'" v-if="hasTable" v-on:click="toggleTable()" />
            </div>
            <div class="chart" v-show="!showTable">
                <div v-for="gauge in filteredData()" v-on:click="zoomIn(gauge.id)">
                    <gauge :content="gauge.content" :label="gauge.label"></gauge>
                </div>
            </div>
            <div class="table-data" v-show="showTable">
                <table class="table">
                    <thead><tr><th v-for="field in content['tableMetaData']">{{field.label || field}}</th></tr></thead>
                    <tbody><tr v-for="row in filteredTableData()" v-bind:class="tableClickable(row['id'])" v-on:click="zoomIn(row['id'])" ><td v-for="field in trimmedRowData(row)">{{field}}</td></tr></tbody>
                </table>
            </div>
        </div>
        <div class="error-container alert alert-danger" v-if="isDataLoaded && hasError">
            {{error}}
        </div>
        <div class="chart-generation-date" v-if="isDataLoaded && hasGenDate">
            Data generated at: {{content['genDate']}}
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import querystring from 'querystring'
    import Loader from '@/components/Loader'
    import Gauge from '@/components/charts/Gauge'
    import ChartMixin from '@/mixins/ChartMixin.js'

    export default {
        props: ['contentSource', 'id'],
        mixins: [ChartMixin],
        name: 'gaugeTier',
        data () {
            return {
                filter: null,
                filterOptions: [],
                content: null,
                components: {},
                dataSets: {},
                dataZoom: [],
                tableView: false
            }
        },
        computed: {
            hasFilter () {
                return this.filter !== null
            },
            hasGenDate () {
                return this.content.genDate !== undefined && this.content.genDate !== null
            },
            hasTable () {
                return this.content.tableData !== undefined && this.content.tableData !== null
            },
            showTable () {
                return this.hasTable && this.tableView
            },
            isDataLoaded () {
                return this.content !== null
            },
            hasError () {
                return this.content.error !== undefined && this.content.error !== null
            },
            error () {
                return this.content.error || 'An unknown error has occurred'
            },
            parent () {
                return this.dataZoom[this.dataZoom.length - 1] || 0
            }
        },
        methods: {
            breadcrumbClickable (index) {
                return this.dataZoom.length - 1 > index ? 'clickable' : ''
            },
            tableClickable (id) {
                return this.hasChildren(id, this.content.data) ? 'clickable' : ''
            },
            toggleTable () {
                this.tableView = !this.tableView

                this.$nextTick(function () {
                    window.dispatchEvent(this.forceResize)
                })
            },
            parentLabel (parent) {
                const data = this.content.data.filter((data) => data.id === parent)
                return data.length ? data[0].label || '' : ''
            },
            getData () {
                this.content = null
                let self = this
                return axios.post(this.contentSource, querystring.stringify(Object.assign({id: this.id}, this.filter)), {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
                    .then(function (response) {
                        if (response.data.result) {
                            self.setData(self, response.data.content)
                        } else {
                            self.setData(self, {error: response.data.message || 'An unknown error has occurred'})
                        }
                    })
                    .catch((error) => {
                        if (error instanceof Error) {
                            self.setData(self, {error: error.message || 'An unknown error has occurred'})
                        }
                    })
            },
            filteredData () {
                const self = this

                return this.content.data.filter(data => {
                    return data.parent === self.parent
                })
            },
            dataZoomReset () {
                this.dataZoom = []
            },
            breadcrumbZoomOut (index) {
                if (index + 1 < this.dataZoom.length) {
                    this.dataZoomOut(this, this.dataZoom[index + 1])
                }
            },
            zoomIn (id) {
                if (this.hasChildren(id, this.content.data)) {
                    this.dataZoomIn(this, id)
                } else {
                    this.dataZoomOut(this)
                }
            },
            filteredTableData () {
                if (this.hasTable) {
                    const self = this

                    return this.content.tableData.filter(data => {
                        return data.parent === self.parent
                    })
                }
            },
            trimmedRowData (row) {
                return this.trimRow(row, this.content.tableMetaData)
            }
        },
        created () {
            if (this.contentSource !== undefined && this.contentSource !== null) {
                this.getData()
            }

            this.forceResize = new CustomEvent('resize')
        },
        components: { Loader, Gauge }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// GaugeTier.vue?d22afdbc